import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";

interface IBrazilianCompanyIssuerExternalLinksProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

function BrazilianCompanyIssuerExternalLinks({ issuer }: IBrazilianCompanyIssuerExternalLinksProps) {
  return (
    <div className="flex h-10 items-center divide-x divide-slate-100">
      {issuer.investorRelationsUrl && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
          href={issuer.investorRelationsUrl}
        >
          Site de RI
        </a>
      )}

      {!issuer.investorRelationsUrl && issuer.website && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={issuer.investorRelationsUrl}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>Website</span>
        </a>
      )}

      {issuer.cvmCode && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://sistemaswebb3-listados.b3.com.br/listedCompaniesPage/main/${issuer.cvmCode}/${issuer.tickerSymbolPrefix}/overview?language=pt-br`}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>Site B3</span>
        </a>
      )}
    </div>
  );
}

export default BrazilianCompanyIssuerExternalLinks;
